/**
 * @generated SignedSource<<b05aa0a329f1e023b115fdd08032ed91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostVoteType = "DOWN" | "NONE" | "UP" | "%future added value";
export type postBottomActionsCreateVoteMutation$variables = {
  postId: string;
  vote: PostVoteType;
};
export type postBottomActionsCreateVoteMutation$data = {
  readonly registerVote: {
    readonly id: string;
    readonly userVote?: {
      readonly vote: PostVoteType;
    } | null | undefined;
    readonly votes?: number;
  };
};
export type postBottomActionsCreateVoteMutation = {
  response: postBottomActionsCreateVoteMutation$data;
  variables: postBottomActionsCreateVoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "postId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vote"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "postId",
    "variableName": "postId"
  },
  {
    "kind": "Variable",
    "name": "vote",
    "variableName": "vote"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PostVote",
      "kind": "LinkedField",
      "name": "userVote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vote",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postBottomActionsCreateVoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "registerVote",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postBottomActionsCreateVoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "registerVote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7001ba0323cba97d8204074002366fed",
    "id": null,
    "metadata": {},
    "name": "postBottomActionsCreateVoteMutation",
    "operationKind": "mutation",
    "text": "mutation postBottomActionsCreateVoteMutation(\n  $postId: ID!\n  $vote: PostVoteType!\n) {\n  registerVote(postId: $postId, vote: $vote) {\n    __typename\n    id\n    ... on Post {\n      votes\n      userVote {\n        vote\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f240c2cd0924370ed785881ff00bf11";

export default node;
